<div class="container" [attr.data-testid]="automationKey">
  @if (radioNodeMap) {
    <jmkw-radios
      [radioNodeMap]="radioNodeMap"
      [selectedId]="selectedThemeId()"
    ></jmkw-radios>
  }
</div>
